import { BaseModel } from './BaseModel';

export class UserModel extends BaseModel {

  userId: number;
  userName: string;
  password: string;
  confirmPassword: string;
  emailAddress: string;
  hashedPassword: string;
  userRoleId: number;
  countryId: number;
  schoolId: number;
  isActive: Boolean = true;
  createdBy: number;
  updatedBy: number;
  userRole: string;
  constructor() {
    super();
    this.userName = '';
    this.userId = 0;
    this.emailAddress = '';
    this.confirmPassword = '';
    this.hashedPassword = '';
    this.userRoleId = 0;
    this.countryId = null;
    this.isActive = true;
    this.createdBy = null;
    this.updatedBy = null;
    this.userRole = '';
    this.schoolId = null;
  }
}

